/**
 * There will be one reducer file per page / common component
 */
import {
    GET_PRODUCTSGUIDE_SUCCESS,
    GET_PRODUCTSGUIDE_FAILURE,
    GET_PRODUCTSGUIDE,
    SET_PRODUCTSGUIDE,
    GET_PRODUCT_BRAND_AND_CATEGORY_DATA,
    GET_PRODUCT_BRAND_AND_CATEGORY_DATA_SUCCESS,
    GET_PRODUCT_BRAND_AND_CATEGORY_DATA_FAILURE,
    GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY,
    GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY_SUCCESS,
    GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY_FAILURE,
    CLEAR_PRODUCTS_GUIDE,
} from '../actions';

const initialState = {
    selectedBrands: [],
    selectedSubCategory: [],
    productGuideData: {
        subCategoryRefineData: [
            {
                subCategoryClassificationCode: '',
                subCategoryClassificationName: '',
                classificationRefineData: [], //checked
            },
        ],
    },
    pageNum: 0,
    pageLimit: 50,
    categoryAndBrands: {},
    productsGuideError: '',
    categoryAndBrandLoading: false,
    productsGuideLoading: false,
    subCategoryLoading: false,
};

const updateProductsGuide = (list, name, state) => {
    if (name === 'approach') {
        return {
            ...state,
            subCategoryRefineData: list,
        };
    }
    if (name === 'pageNum') {
        return {
            ...state,
            pageNum: list,
        };
    }
    if (name === 'productBrands') {
        return {
            ...state,
            selectedBrands: list,
        };
    }
};

const ProductsGuideReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_PRODUCTSGUIDE:
            return {
                ...state,
                ...updateProductsGuide(action.payload, action.name, state),
            };
        case GET_PRODUCTSGUIDE:
            return {
                ...state,
                productsLoading: true,
            };
        case GET_PRODUCTSGUIDE_SUCCESS:
            return {
                ...state,
                productsGuide: action.productsGuide,
                productsGuideError: '',
                productsGuideLoading: false,
            };
        case GET_PRODUCTSGUIDE_FAILURE:
            return {
                ...state,
                productsGuide: [],
                productsGuideError: action.templateError,
                productsGuideLoading: false,
            };
        case GET_PRODUCT_BRAND_AND_CATEGORY_DATA:
            return {
                ...state,
                categoryAndBrandLoading: true,
            };
        case GET_PRODUCT_BRAND_AND_CATEGORY_DATA_SUCCESS:
            return {
                ...state,
                categoryAndBrands: action.categoryAndBrands,
                productsGuideError: '',
                categoryAndBrandLoading: false,
            };
        case GET_PRODUCT_BRAND_AND_CATEGORY_DATA_FAILURE:
            return {
                ...state,
                categoryAndBrands: [],
                productsGuideError: action.templateError,
                categoryAndBrandLoading: false,
            };
        case GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY:
            return {
                ...state,
                subCategoryLoading: true,
            };
        case GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY_SUCCESS:
            return {
                ...state,
                productGuideData: action.productGuideData,
                categoryAndBrands: {
                    ...state.categoryAndBrands,
                    brandData: action.productGuideData.brandRefineData,
                    categoryData:
                        action.productGuideData?.categoryData ||
                        state.categoryAndBrands.categoryData,
                },
                productsGuideError: '',
                subCategoryLoading: false,
            };
        case GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY_FAILURE:
            return {
                ...state,
                productGuideData: [],
                productsGuideError: action.templateError,
                subCategoryLoading: false,
            };
        case CLEAR_PRODUCTS_GUIDE:
            return {
                ...state,
                productGuideData: [],
            };

        default: {
            return { ...state };
        }
    }
};

export default ProductsGuideReducer;
